import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from '../services/data.service';
import { API_ENDPOINT$ } from '../shared/index';

@Injectable({
  providedIn: 'root'
})
export class EqBenchmarkingService {
  private getProcessAndLoadsBySiteIdURL = `${API_ENDPOINT$}/common/getProcessAndLoadsBySiteId`;
  private fetchAllProductsURL = `${API_ENDPOINT$}/common/fetchAllProducts`;
  private savePlanQForLoadsURL = `${API_ENDPOINT$}/manageproject/savePlanQForLoads`;
  private getShiftsBySiteIdURL = `${API_ENDPOINT$}/common/getShiftsBySiteId`;
  private getLoadsByQUseFromLiveDataURL = `${API_ENDPOINT$}/common/getLoadsByQUseFromLiveData`;
  private saveActualQForLoadURL = `${API_ENDPOINT$}/manageproject/saveActualQForLoad`;

  public savePlanQForLoads(model: any): Observable<any> {
    return this.dataService.postData(this.savePlanQForLoadsURL, model);
  }
  public getProcessAndLoadsBySiteId(siteId: string): Observable<any> {
    return this.dataService.getData(
      this.getProcessAndLoadsBySiteIdURL + '/' + siteId + '/' + false
    );
  }

  public fetchAllProducts(): Observable<any> {
    return this.dataService.getData(this.fetchAllProductsURL);
  }

  public getShiftsBySiteId(siteId: string): Observable<any> {
    return this.dataService.getData(this.getShiftsBySiteIdURL + '/' + siteId);
  }

  public getLoadsByQUseFromLiveData(
    siteId: string,
    date: string
  ): Observable<any> {
    return this.dataService.getData(
      this.getLoadsByQUseFromLiveDataURL + '/' + siteId + '/' + date
    );
  }

  public saveActualQForLoad(model: any): Observable<any> {
    return this.dataService.postData(this.saveActualQForLoadURL, model);
  }
  constructor(private dataService: DataService) {}
}
